export function startDrag(clientX, refs) {
  refs.isDraggingRef.current = true;
  refs.startXRef.current = clientX;
  refs.currentXRef.current = clientX;
}

export function moveDrag(clientX, refs, setDragOffset) {
  if (!refs.isDraggingRef.current) return;

  refs.currentXRef.current = clientX;
  const delta = clientX - refs.startXRef.current;
  refs.deltaXRef.current = delta;

  setDragOffset(delta);
}

export function endDrag(refs, homeMealIndex, goToHomeViewerMeal, setDragOffset) {
  if (!refs.isDraggingRef.current) return;

  const delta = refs.deltaXRef.current;

  const threshold = 60;
  const velocity = Math.abs(delta);

  if (delta < -threshold || (delta < -20 && velocity > 80)) {
    goToHomeViewerMeal(homeMealIndex + 1);
  } else if (delta > threshold || (delta > 20 && velocity > 80)) {
    goToHomeViewerMeal(homeMealIndex - 1);
  }

  setDragOffset(0);
  refs.isDraggingRef.current = false;
  refs.deltaXRef.current = 0;
}

export function handleTouchStart(e, refs) {
  startDrag(e.touches[0].clientX, refs);
}

export function handleTouchMove(e, refs, setDragOffset) {
  moveDrag(e.touches[0].clientX, refs, setDragOffset);
}

export function handleTouchEnd(refs, homeMealIndex, goToHomeViewerMeal, setDragOffset) {
  endDrag(refs, homeMealIndex, goToHomeViewerMeal, setDragOffset);
}

export function handleMouseDown(e, refs) {
  startDrag(e.clientX, refs);
}

export function handleMouseMove(e, refs, setDragOffset) {
  moveDrag(e.clientX, refs, setDragOffset);
}

export function handleMouseUp(refs, homeMealIndex, goToHomeViewerMeal, setDragOffset) {
  endDrag(refs, homeMealIndex, goToHomeViewerMeal, setDragOffset);
}